import RouteProvider from './RouteProvider';

class RouteService {
  constructor({ target }) {
    this._target = target;
  }

  getRoute() {
    return RouteProvider.currentTarget;
  }

  routeTo(subTarget) {
    RouteProvider.push(this._target, subTarget);
  }

  routeToReplace(subTarget){
    RouteProvider.replace(this._target, subTarget);
  }

  subscribeToRoute(callback) {
    return RouteProvider.subscribe(callback);
  }

  static build(...args) {
    return new RouteService(...args);
  }
}

export default RouteService;
